import { NgModule } from "@angular/core";
import { PaginatorStyleDirective } from "./paginator-style.directive";

@NgModule({
    declarations: [
        PaginatorStyleDirective
    ],
    exports: [
        PaginatorStyleDirective
    ]
})
export class FinzyFlexDirectiveModule {}